var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsYoga(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-1 0 27 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-yoga") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-yoga",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    transform: "translate(13.000000, 3.000000) scale(-1, 1) translate(-13.000000, -3.000000) ",
    cx: 13,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1590909,19.5384615 L17.3113636,19.5384615 L14.4443182,15.7965385 C14.289018,15.5940347 14.2046449,15.3447357 14.2045455,15.0880769 L14.2045455,11.4615385 L23.2954545,11.4615385 C24.236849,11.4615385 25,10.6866467 25,9.73076923 C25,8.77489178 24.236849,8 23.2954545,8 L1.70454545,8 C0.763150995,8 0,8.77489178 0,9.73076923 C0,10.6866467 0.763150995,11.4615385 1.70454545,11.4615385 L10.7954545,11.4615385 L10.7954545,14.3461538 L8.52272727,14.3461538 C6.3261402,14.3461538 4.54545455,16.1542347 4.54545455,18.3846154 L4.54545455,21.2692308 C4.54545457,22.2251082 5.30860555,23 6.25,23 C7.19139445,23 7.95454543,22.2251082 7.95454545,21.2692308 L7.95454545,18.3846154 C7.95454545,18.0659896 8.20892912,17.8076923 8.52272727,17.8076923 L11.6670455,17.8076923 L15.1329545,22.3319231 C15.4556598,22.7531478 15.9516941,22.9996587 16.4772727,23 L22.1590909,23 C23.1004854,23 23.8636364,22.2251082 23.8636364,21.2692308 C23.8636364,20.3133533 23.1004854,19.5384615 22.1590909,19.5384615 Z",
    id: "Path",
    transform: "translate(12.500000, 15.500000) scale(-1, 1) translate(-12.500000, -15.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 14.5,
    x2: 14,
    y2: 14.5,
    id: "Path",
    transform: "translate(12.500000, 14.500000) scale(-1, 1) translate(-12.500000, -14.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsYoga);
export default __webpack_public_path__ + "static/media/icons-yoga.24630dbc40bfc90ab6218bfdb562ff09.svg";
export { ForwardRef as ReactComponent };